const isPrimaryPointer = (event) => {
  if (event.pointerType === "mouse") {
    return typeof event.button !== "number" || event.button <= 0;
  } else {
    return event.isPrimary !== false;
  }
};
export {
  isPrimaryPointer
};
//# sourceMappingURL=is-primary-pointer.js.map
